import Button from "@components/ui/button";
import Icon from "@components/ui/icon";
import { MediaLibFilesSkeleton } from "../../files/media-lib-files-skeleton";

interface IProps {
  onReload: () => void;
}

export const MediaLibPanelError = ({ onReload }: IProps) => {
  return (
    <div className="tw-relative tw-flex tw-h-full tw-flex-col tw-items-center tw-overflow-hidden tw-pt-10 tw-text-center">
      <div className="tw-z-1 tw-mt-12">
        <Icon
          icon="ri-error-warning-fill"
          className="tw-text-[24px]/none tw-text-red-base"
        />
        <div className="tw-text-md tw-mb-4 tw-mt-1 tw-font-medium">
          Failed to load, please try again
        </div>

        <Button variant="secondary" size="sm" onClick={onReload}>
          <Icon icon="ri-refresh-line" className="tw-mr-1.5" />
          Reload
        </Button>
      </div>

      <div className="tw-absolute tw-left-0 tw-top-0 tw-w-full tw-opacity-60">
        <MediaLibFilesSkeleton noAnim />
      </div>
    </div>
  );
};
